module.exports = __webpack_public_path__ + "img/c8.5cc81c10.png";